import React from "react";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Text,
} from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickLandingSection from "@/features/pathpick/features/landing/components/PathPickLandingSection";
import {
  FAQ_ITEM_KEYS,
  PATHPICK_LANDING_COLORS,
} from "@/features/pathpick/features/landing/constants";

// 자주 묻는 질문. 항목은 FAQPage 구조화 데이터(index.tsx)와 같은 키 목록을 쓴다.
function PathPickLandingFaqSection() {
  const { t } = useI18nHelper();

  return (
    <PathPickLandingSection title={t("path_pick_landing:faq.title")}>
      <Accordion allowMultiple>
        {FAQ_ITEM_KEYS.map((key) => (
          <AccordionItem
            key={key}
            borderTopWidth={"1px"}
            borderBottomWidth={"1px"}
            borderColor={PATHPICK_LANDING_COLORS.divider}
          >
            <Text as={"h3"}>
              <AccordionButton paddingX={"0px"} paddingY={"18px"}>
                <Text
                  flex={"1"}
                  textAlign={"left"}
                  textStyle={"body-md-bold"}
                  fontSize={{ base: "15px", lg: "16px" }}
                  color={PATHPICK_LANDING_COLORS.textStrong}
                >
                  {t(`path_pick_landing:faq.items.${key}.question`)}
                </Text>
                <AccordionIcon color={PATHPICK_LANDING_COLORS.textFaint} />
              </AccordionButton>
            </Text>
            <AccordionPanel paddingX={"0px"} paddingBottom={"20px"}>
              <Text
                textStyle={"body-sm-regular"}
                color={PATHPICK_LANDING_COLORS.textMuted}
              >
                {t(`path_pick_landing:faq.items.${key}.answer`)}
              </Text>
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </PathPickLandingSection>
  );
}

export default PathPickLandingFaqSection;
